import $ from 'jquery';
// import 'owl.carousel';

class ImagesCarousel {
  constructor() {
    this.carousels = $('.js-owl-carousel');
    this.speed = 1000;

    this.carousel();
  }

  carousel() {
    if (!this.carousels.length) {
      return;
    }

    import('owl.carousel').then(() => {
      this.initCarousels();
    });
  }

  initCarousels() {
    $.each(this.carousels, (i, el) => {
      const carousel = $(el);

      const columns = carousel.data('carousel-items') || 3;
      const isAutoplay = carousel.data('carousel-autoplay') === 'yes';
      const isLoop = carousel.data('carousel-loop') === 'yes';
      const timeout = carousel.data('carousel-timeout') * 1000;
      const type = carousel.data('carousel-type') || 'images';
      const showNav = carousel.data('carousel-nav') || 'no';

      const params = {
        dots: false,
        nav: showNav === 'yes',
        navText: [
          '<span class="c-svg-icon c-svg-icon--angle-left" aria-hidden="true"><svg class="c-icon c-icon--angle-left" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 11 28"><use xlink:href="#c-icon--angle-left"></use></svg></span>',
          '<span class="c-svg-icon c-svg-icon--angle-right" aria-hidden="true"><svg class="c-icon c-icon--angle-right" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 9 28"><use xlink:href="#c-icon--angle-right"></use></svg></span>',
        ],
        mouseDrag: true,
        touchDrag: true,
        navSpeed: this.speed,
        dotsSpeed: this.speed,
        dragEndSpeed: this.speed,
        loop: isLoop,
        autoplay: isAutoplay,
        autoplaySpeed: this.speed,
        autoplayTimeout: timeout,
        autoplayHoverPause: true,
        stagePadding: 0,
      };

      switch (type) {
        case 'testimonials':
          params.stagePadding = 10;

          switch (columns) {
            case 2:
              params.responsive = {
                0: {
                  items: 1,
                  margin: 15,
                  stagePadding: 40,
                },
                360: {
                  items: 1,
                  margin: 15,
                  stagePadding: 70,
                },
                500: {
                  items: 1,
                  margin: 15,
                  stagePadding: 100,
                },
                768: {
                  items: 2,
                  margin: 25,
                  stagePadding: 0,
                },
              };
              break;
            case 3:
              params.responsive = {
                0: {
                  items: 1,
                  margin: 15,
                  stagePadding: 40,
                },
                360: {
                  items: 1,
                  margin: 15,
                  stagePadding: 70,
                },
                500: {
                  items: 1,
                  margin: 15,
                  stagePadding: 100,
                },
                768: {
                  items: 2,
                  margin: 15,
                  stagePadding: 0,
                },
                1024: {
                  items: 3,
                  margin: 25,
                },
              };
              break;
            default:
              params.items = 1;
              params.margin = 0;
          }
          break;
        default:
          switch (columns) {
            case 2:
              params.responsive = {
                0: {
                  items: 2,
                  stagePadding: 0,
                },
              };
              break;
            case 3:
              params.responsive = {
                0: {
                  items: 2,
                  stagePadding: 20,
                },
                360: {
                  items: 2,
                  stagePadding: 60,
                },
                480: {
                  items: 3,
                  stagePadding: 0,
                },
              };
              break;
            case 4:
              params.responsive = {
                0: {
                  items: 3,
                  stagePadding: 20,
                },
                360: {
                  items: 3,
                  stagePadding: 60,
                },
                480: {
                  items: 4,
                  stagePadding: 0,
                },
              };
              break;
            case 5:
              params.responsive = {
                0: {
                  items: 3,
                  stagePadding: 20,
                },
                360: {
                  items: 3,
                  stagePadding: 60,
                },
                480: {
                  items: 4,
                  stagePadding: 0,
                },
                768: {
                  items: 4,
                  stagePadding: 0,
                },
                1024: {
                  items: 5,
                },
              };
              break;
            default:
              params.items = 1;
              params.margin = 0;
          }
          break;
      }

      carousel.owlCarousel(params);
    });
  }
}

export default new ImagesCarousel();



// WEBPACK FOOTER //
// ./src/scripts/modules/carousels.js